
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import MiezzModal from "@/models/MiezzModal";
import ExemptionNatureAppService from "@/apis.machine/ExemptionNatureAppService";
import DtoFormExemptionNature, {
  DtoFormExemptionNatureMiezzFormItems,
  DtoFormExemptionNatureRules,
} from "@/models.machine/DtoFormExemptionNature";

export default class ExemptionNatureForm extends Vue {
  @Model() modelValue!: MiezzModal;
  @Prop() id?: string;

  form = new MiezzForm<DtoFormExemptionNature, string>();
  NameList: string[] = [];

  created(): void {
    //表单-数据-初始化
    this.form.Data = new DtoFormExemptionNature();
    //表单-校验
    this.form.Rules = DtoFormExemptionNatureRules;
    this.form.Rules.Abbr = [
      {
        required: true,
        message: "信息不能为空",
        trigger: "blur",
      },
      {
        required: true,
        validator: (rule: any, value: string, callback: any) => {
          if (this.form.Data.Abbr != null && typeof (this.form.Data.Abbr) != "undefined" && this.form.Data.Abbr != "undefined" && this.form.Data.Abbr != "") {
            var Abbr = this.form.Data.Abbr.trim();
            if (this.NameList.some(it => it == Abbr)) {
              callback(new Error("信息重复，请重新填写"));
              return false;
            } else {
              return callback();
            }
          }
          else {
            return callback();
          }
        },
        trigger: "blur",
      },
    ];
    //表单-元素配置
    this.form.Items = DtoFormExemptionNatureMiezzFormItems;

    //修改元素配置
    //for (const item of this.form.Items) {
    //  switch (item.Prop) {
    //    default:
    //      break;
    //  }
    //}

    this.modelValue.HandleClick = this.handleClick;
    this.modelValue.Buttons = [
      {
        Code: "submit",
        Label: "保存",
        Type: "primary",
        Size: "small",
      },
    ];

    this.handleGet();
  }

  onBlur(): void {
    var optName:Array<string> = [];
    
    if (this.form.Data.Abbr) {
      optName?.push(this.form.Data.Abbr);
    }
    if (this.form.Data.Code) {
      optName?.push(this.form.Data.Code);
    }
    
    this.form.Data.Name = optName.join("/");
  }

  onBlurAbbr(): void {
    if (this.form.Data.Abbr) {
      this.form.Data.Abbr = this.form.Data.Abbr.trim();
    }
    this.onBlur();
  }

  onBlurCode(): void {
    if (this.form.Data.Code) {
      this.form.Data.Code = this.form.Data.Code.toUpperCase();
      this.form.Data.Code = this.form.Data.Code.trim();
    }
    this.onBlur();
  }

  /**查询表单数据 */
  handleGet(): void {
    ExemptionNatureAppService.GetNameList().then((r1) => {
      if (r1.data.Data) this.NameList = r1.data.Data;

      if (this.id) {
        ExemptionNatureAppService.GetById(this.id).then((r) => {
          if (r.data.Data) {
            this.form.Data = r.data.Data;

            var index = this.NameList.findIndex(it => { return it == this.form.Data.Abbr });
            this.NameList.splice(index, 1);
          }
        });
      }
    })
    
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "submit":
        MiezzForm.submit(this.$refs, "ruleForm", (v) => {
          if (v) {
            ExemptionNatureAppService.Post(this.form.Data)
              .then(() => {
                this.handleSubmit();
                complete();
              })
              .catch(complete);
          } else complete();
        });
        break;
      default:
        break;
    }
  }

  /**表单提交-回调 */
  @Emit()
  handleSubmit(): void {
    //
  }
}
